import { Text } from "@mantine/core";
import { IconMapPin } from "@tabler/icons-react";
import InfoItem from "components/InfoItem";

interface ChatContextLocationItemProps {
  locationName?: string | null;
  locationAddress?: string | null;
  locationZipCode?: string | null;
  locationCityName?: string | null;
  countryCode?: string | null;
}

const ChatContextLocationItem: React.FC<ChatContextLocationItemProps> = ({
  locationName,
  locationAddress,
  locationZipCode,
  locationCityName,
  countryCode,
}) => (
  <InfoItem
    gap={8}
    align="flex-start"
    visible={!!locationName}
    icon={<IconMapPin className="w-6 h-6" />}
    label={
      <>
        <Text fz={14} className="w-full">
          {locationName}
        </Text>
        <Text fz={14} className="w-full">
          {locationAddress}
        </Text>
        <Text fz={14} className="w-full">
          {locationZipCode} {locationCityName} {countryCode}
        </Text>
      </>
    }
  />
);

export default ChatContextLocationItem;
